export default __webpack_public_path__ + "static/media/Late-noon.d3d2b1e7.jpg";